import { Money } from '../../../../types';

export const addMoney = (acc: Money | undefined, next: Money): Money => {
	if (!acc) {
		return { ...next };
	}

	return {
		amount: (acc.amount ?? 0) + (next.amount ?? 0),
		currency: acc.currency ?? next.currency
	};
};
